// ./src/components/loadings/LoadingSuspense/index.tsx
import React from 'react';

import { LottieDots } from '@assets/animations';

import { Container, Content } from './styles';

const LoadingSuspense: React.FC = () => {
  return (
    <Container>
      <Content>
        <LottieDots />
      </Content>
    </Container>
  );
};

export default LoadingSuspense;
